import { Dto, DtoWithId } from "@mango/core";
import { TypeCalculatie } from './type-calculatie';
import { Relatie } from "./relatie";
import { InstrumentDefinitie } from "./instrument-definitie";
import { Rubriek } from "./rubriek";
import { Personeel } from "./personeel";
import { Groep } from "../enums/groep";
import { Contactpersoon } from "./contactpersoon";
import { Voorblad } from "./voorblad";
import { Volgblad } from "./volgblad";

@Dto({fullName: "CIJBorculo.Logic.Instrument"})
export class Instrument extends DtoWithId {
	oldID: number;
	relatie: Relatie;
	instrumentDefinitie: InstrumentDefinitie;
	personeel: Personeel;
	groep: Groep;
	typeCalculatie: TypeCalculatie;
	naam: string;
	afdeling: string;
	eMail: string;
	nr_Instrument: string;
	nr_Fabriek: string;
	nr_Barcode: string;
	nr_Referentie: string;
	lokatie: string;
	soort: string;
	merk: string;
	type: string;
	enbouwjaar: number;
	entoelatingscode: string;
	eNcode: string;
	enunom: string;
	eninom: string;
	memo: string;
	dKalibratie: Date;
	dOproep: Date;
	periode: number;
	voorbladID: Voorblad;
	volgbladID: Volgblad;
	oproep: boolean;
	isVervallen: boolean;
	isWerkstandaard: boolean;
	certificaat: string;
	opmerking: string;
	referentieMI: boolean;
	personeel_CrossID: Personeel;
	bContact: Contactpersoon;
	isUsed: number;
	isVerlopen: boolean;
	dVerlopen: Date;
	centixId: number;
	lastExportCentix: Date;
	lastExportCentixDoor: string;
	reasonNotExported: string;
}